export class ObjectStatusConstants {
  static PriorAuthorization = {
    AwaitingWcbCaseNumber: 1,
    ClosedNoMatch: 2,
    ClosedNoValidWcbCaseNumber: 3,
    MultipleWcbCasesFound: 4,
    L1ReviewRequested: 5,
    L1GrantedFinal: 6,
    L1GrantedInPart: 7,
    L1GrantedInPartFinal: 8,
    L1Denied: 9,
    L1DeniedFinal: 10,
    L1GrantedAfterDenialFinal: 11,
    L2ReviewRequested: 12,
    L2GrantedFinal: 13,
    L2GrantedInPart: 14,
    L2GrantedInPartFinal: 15,
    L2Denied: 16,
    L2DeniedFinal: 17,
    L2GrantedAfterDenialFinal: 18,
    L3ReviewRequested: 20,
    L3ReviewRequestedFinal: 21,
    L3GrantedFinal: 28,
    L3GrantedInPartFinal: 29,
    L3DeniedFinal: 30,
    L3ReviewRejected: 31,
    L3ReviewNoResponse: 32,
    OotcIssuedGranted: 33,
    NoResponse: 34,
    DeniedFinal: 35,
    DeniedImeRelated: 36,
  };
  static MdoReview = {
    ReadyForReviewNoResponse: 19,
    EscalatedForReview: 22,
    ReadyForSupervisorReview: 23,
    SupervisorReviewCompleteConditionallyApproved: 24,
    DeterminationSent: 25,
    NoticeOfRejectionSent: 26,
    InsurerGrantedAfterDenial: 27,
    ReadyForReviewInsurerUndetermined: 42,
    PendingUracReview: 43,
    PendingUracExpeditedReview: 44,
    PendingUracExtendedReview: 45,
    NoUracResponseReadyForReview: 46,
    NoExpeditedUracResponse: 47,
    NoExtendedUracResponse: 48,
    UracReviewComplete: 57,
    ProposedRejectionRfa: 58,
    SupervisorReviewCompleteRejected: 59,
  };
}
